(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("feedback-widget", [], factory);
	else if(typeof exports === 'object')
		exports["feedback-widget"] = factory();
	else
		root["feedback-widget"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 